import { createSlice } from '@reduxjs/toolkit';

// Функция для получения начального состояния из localStorage
const getInitialDarkMode = () => {
    const saved = localStorage.getItem('darkMode');
    return saved ? JSON.parse(saved) : false;
};

// Функция для установки атрибута темы
// CSS переменные автоматически меняются через селектор [data-theme="dark"] в App.css
const setThemeAttribute = (isDark) => {
    const root = document.documentElement;
    root.setAttribute('data-theme', isDark ? 'dark' : 'light');
    // Также устанавливаем для MUI
    root.setAttribute('data-mui-color-scheme', isDark ? 'dark' : 'light');
};

const initialState = {
    darkMode: getInitialDarkMode(),
};

// Устанавливаем начальный атрибут темы
setThemeAttribute(getInitialDarkMode());

export const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        toggleDarkMode: (state) => {
            state.darkMode = !state.darkMode;
            // Сохраняем в localStorage
            localStorage.setItem('darkMode', JSON.stringify(state.darkMode));
            // Устанавливаем атрибут темы (CSS переменные меняются автоматически через App.css)
            setThemeAttribute(state.darkMode);
        },
        setDarkMode: (state, action) => {
            state.darkMode = action.payload;
            // Сохраняем в localStorage
            localStorage.setItem('darkMode', JSON.stringify(state.darkMode));
            // Устанавливаем атрибут темы (CSS переменные меняются автоматически через App.css)
            setThemeAttribute(state.darkMode);
        },
    },
});

export const { toggleDarkMode, setDarkMode } = settingsSlice.actions;

export default settingsSlice.reducer;
